/**
 * WordPress dependencies
 */

const BaseWrapper = ( props ) => {
	const { children, name } = props;
	// const { blockClientId } = attributes;
	const baseClass = name.replace( '/', '-' ) + '-section';
	// const _blockClientId = '' !== blockClientId ? blockClientId : clientId;

	// const id = 'undefined' !== typeof sectionID && '' !== sectionID ? `gutenify-section-${ sectionID }` : `gutenify-section-${ _blockClientId }`;
	return <div className={ baseClass }>{ children }</div>;
};
export default BaseWrapper;
